module.exports = __webpack_public_path__ + "img/belgium.0868d7aa.png";